import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyllabusHttpModel } from '@examdojo/category';
import { environment } from '@examdojo/core/environment';
import { UserHttpModel } from '@examdojo/models/user';
import { ExamdojoSupabaseService, SupabaseBaseHttpService, TableRowModel } from '@examdojo/supabase';
import { from } from 'rxjs';
import {
  DerivativeQuestionReviewType,
  ReferenceQuestionReviewType,
  ReviewItemHttpModel,
} from './review-item/review-item.model';

const baseUrl = environment.examdojo.examdojoApiUrl;
type ReviewItemId = ReviewItemHttpModel['id'];

@Injectable({ providedIn: 'root' })
export class CurrentReviewHttpService extends SupabaseBaseHttpService<'current_reviews', 'review'> {
  constructor(
    private readonly http: HttpClient,
    private readonly supabaseService: ExamdojoSupabaseService,
  ) {
    super(supabaseService);
  }

  readonly schema = 'review';
  readonly tableName = 'current_reviews';
  override id_field: keyof TableRowModel<'current_reviews', 'review'> = 'reviewable_item_id';

  getNextQuestion(
    reviewType: DerivativeQuestionReviewType | ReferenceQuestionReviewType,
    syllabusId: SyllabusHttpModel['id'],
  ) {
    return this.http.get(`${baseUrl}/review/next-reviewable-item/syllabus/${syllabusId}/questions/${reviewType}`);
  }

  getNextReferenceQuestion(reviewType: ReferenceQuestionReviewType, syllabusId: SyllabusHttpModel['id']) {
    return this.http.get(
      `${baseUrl}/review/next-reviewable-item/syllabus/${syllabusId}/reference-questions/${reviewType}`,
    );
  }

  skipQuestion(userId: UserHttpModel['id'], reviewItemId: ReviewItemId) {
    return from(
      this.supabaseService.client
        .schema('review')
        .from('skips')
        .insert({
          user_id: userId,
          reviewable_item_id: reviewItemId,
        })
        .throwOnError(),
    ).pipe();
  }

  cancelQuestion(reviewItemId: ReviewItemId) {
    return this.delete(reviewItemId);
  }
}
